export const REGISTRATION_COMPLETE_TITLE = 'Поздравляем!';

export const REGISTRATION_COMPLETE_DESCRIPTION =
	'Регистрация закончена и теперь вам открыты все возможности приложения';

export const REGISTRATION_COMPLETE_ACTION_LABEL = 'Начать работу';
